import { CandidateProps } from '../component';

export function CandidateInfoAttributes({ candidate }: CandidateProps) {
  // TODO (open-call-types): Remove these fallbacks once candidate data is always typed for this view.
  const personalAttributes = candidate.data.personalAttributes;
  const formatMeasurement = (value: string | number | null | undefined) =>
    value === null || value === undefined || value === '' ? '' : `${value}cm`;

  return (
    <div className="bg-white">
      <div className="px-4 py-6 text-lg font-bold">Attributes</div>
      <div className="grid grid-cols-[1fr,2fr]">
        <div className="p-4 border-b border-zinc-100">Height</div>
        <div className="p-4 border-b border-zinc-200">
          {formatMeasurement(personalAttributes?.height)}
        </div>
        <div className="p-4 border-b border-zinc-100">Waist</div>
        <div className="p-4 border-b border-zinc-200">
          {formatMeasurement(personalAttributes?.waist)}
        </div>
        <div className="p-4 border-b border-zinc-100">Bust/Chest</div>
        <div className="p-4 border-b border-zinc-200">
          {formatMeasurement(personalAttributes?.chest)}
        </div>
        <div className="p-4 border-b border-zinc-100">Hips</div>
        <div className="p-4 border-b border-zinc-200">
          {formatMeasurement(personalAttributes?.hips)}
        </div>
        <div className="p-4 border-b border-zinc-100">Eyes</div>
        <div className="p-4 border-b border-zinc-200">
          {personalAttributes?.eyeColor ?? ''}
        </div>
      </div>
    </div>
  );
}
